module.exports = __webpack_public_path__ + "img/2_Upper-esophagus.dd78b526.png";